function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Radio, notification } from "antd";
import { Table, Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { PersonFill, GeoAltFill, EnvelopeCheckFill, TelephoneFill, HouseFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditCustomer = function EditCustomer(_ref) {
  var handler = _ref.handler,
    customer = _ref.customer;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormProcessing = _useState6[0],
    setIsFormProcessing = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    var fData = new FormData();
    fData.append("id", customer.id.toString());
    fData.append("name", values.name);
    fData.append("address", values.address);
    fData.append("longitude", values.longitude);
    fData.append("latitude", values.latitude);
    fData.append("mobile", values.mobile);
    fData.append("type", values.type);
    fData.append("email", values.email);
    fData.append("user_id", Common.currentUser.id);
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + "editcustomer", fData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        form.setFieldsValue({
          name: "",
          mobile: "",
          email: ""
        });
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      name: customer.name,
      mobile: customer.mobile,
      geocode: customer.geocode,
      email: customer.email,
      skills: customer.skills,
      type: customer.type
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      size: "large",
      onFinish: onFinish,
      layout: "vertical",
      form: form,
      children: [(errorMessage.length > 0 || successMessage.length > 0) && /*#__PURE__*/_jsxs(Form.Item, {
        children: [successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        name: "type",
        rules: [{
          required: true,
          message: "Veuillez choisir une option"
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          options: [{
            label: /*#__PURE__*/_jsxs("b", {
              children: [/*#__PURE__*/_jsx(HouseFill, {
                size: 16
              }), " Entreprise"]
            }),
            value: 1
          }, {
            label: /*#__PURE__*/_jsxs("b", {
              children: [/*#__PURE__*/_jsx(PersonFill, {
                size: 16
              }), " Particulier"]
            }),
            value: 0
          }],
          optionType: "button"
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "name",
            label: "Nom du prospect",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(PersonFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "Telephone",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(TelephoneFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "geocode",
            label: "Coordonn\xE9es GPS",
            children: /*#__PURE__*/_jsx(Input, {
              suffix: /*#__PURE__*/_jsx(GeoAltFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "email",
            label: "E-mail",
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(EnvelopeCheckFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "MODIFIER"
          })
        })
      })]
    })
  });
};
export default EditCustomer;